export default __webpack_public_path__ + "static/media/phases_drywall_to_clean.efbc535d.webp";